<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-xl-12">
            <div class="card-box">
                
                <div class="form-row">
                    
                    <div class="form-group col-md-5">
                            <label class="col-form-label">
                                <strong>{{$t('string.msg.dashboard.orders.period')}}</strong> 
                            </label>
                            <select v-model="nDays" @change="onChangeDay()"  class="form-control">
                                <option :value="1" selected> {{$t('string.msg.dashboard.orders.change.one.day')}}</option>
                                <option :value="2"> {{$t('string.msg.dashboard.orders.change.two.day')}}</option>
                                <option :value="3"> {{$t('string.msg.dashboard.orders.change.three.day')}}</option>
                                <option :value="7"> {{$t('string.msg.dashboard.orders.change.seven.day')}}</option>
                                <option :value="28"> {{$t('string.msg.dashboard.orders.change.twentyeight.day')}}</option>
                            </select>
                    </div>

                    <div class="form-group col-md-5">
                        <label class="col-form-label"><strong>{{$t('string.msg.dashboard.orders.select.status.label')}}</strong> </label>
                        <select v-model="filters.statusOrder" @change="onChange()"  class="form-control">
                            <option :value="null" selected> {{$t('string.msg.dashboard.orders.select.status.all')}}</option>
                            <option value="WAITING_FOR_RESPONSE"> {{$t('string.msg.dashboard.orders.table.status.waiting')}}</option>
                            <option value="ANSWERED"> {{$t('string.msg.dashboard.orders.table.status.progress')}}</option>
                            <option value="REJECTED"> {{$t('string.msg.dashboard.orders.table.status.reject')}}</option>
                            <option value="PAID"> {{$t('string.msg.dashboard.orders.table.status.closed')}}</option>
                        </select>
                    </div>

                    <div class="form-group col-md-2" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>

                </div>

                <div v-if="items.length==0" class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">{{$t('string.msg.dashboard.no.orders')}}</h5>
                        <p class="card-text">{{$t('string.msg.dashboard.no.orders.description')}}</p>
                    </div>
                </div>

                <div v-if="items.length>0" class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0"></th>
                                <th class="border-top-0">{{$t('string.msg.modal.orders.parts.label.requester')}}</th>
                                <!-- <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.primary.phone.title')}}</th> -->
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.service.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.date.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.status.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.modal.orders.price')}}</th>
                                <th class="border-top-0"></th><th class="border-top-0"></th>
                            </tr>
                        </thead>
                         <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer">
                            <tr v-if="item">
                                <td>
                                    <span v-if="item.isSearchByCompany && item.isSearchByCompany == true">
                                        <i class="dripicons-store"></i>
                                    </span>
                                    <span v-else>
                                        <i class="dripicons-user"></i>
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.isSearchByCompany && item.isSearchByCompany == true && item.company && item.company.fantasyName">
                                        {{camelize(item.company.fantasyName)}}
                                    </span>
                                    <span v-else>
                                        {{`${camelize(item.systemUser.firstName)} ${camelize(item.systemUser.lastName)}`}}
                                    </span>
                                </td>
                                 <!-- <td>
                                    <span v-if="item.systemUser.primaryPhone">
                                        {{(item.systemUser.primaryPhone)}}
                                    </span>
                                </td> -->
                               
                                <td>
                                    <span v-if="item.serviceFamilies">
                                        {{camelize(item.serviceFamilies.name)}}
                                    </span>
                                </td>
                                <td >
                                    <span v-if="item.dateOrder">
                                         {{new Date(item.dateOrder).toLocaleDateString()}} - {{new Date(item.dateOrder).toLocaleTimeString()}}
                                    </span>
                                </td>
                                <td  >
                                    <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'WAITING_FOR_RESPONSE'" style="background-color:#fabc2a; color:black">
                                        &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;
                                    </span>
                                    <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'CLOSED'"  style="background-color:gray; color:white">
                                        &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;
                                    </span>
                                      <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'PAID'" style="background-color:green; color:white">
                                       &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;
                                    </span>
                                    <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'ANSWERED'" style="background-color:blue; color:white">
                                        &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;
                                    </span>
                                    <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'REJECTED'" style="background-color:red; color:white">
                                        &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;
                                    </span>
                                     <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'PENDING_PAY'" style="background-color:orange; color:white">
                                        &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;
                                    </span>
                                </td>
                                <td>
                                    <span  v-if="item.total">
                                        {{$t('string.msg.current.label')}} &nbsp; {{item.total.toFixed(2)}}
                                    </span>
                                    <span v-else>
                                        {{$t('string.msg.current.initial.label')}} 
                                    </span> 
                                </td>
                                <td class="text-center" v-if="item.statusOrder.toUpperCase() == 'PAID'">
                                    <button class="btn btn-danger w-100"  @click="download(item)">{{$t('string.msg.download.orders.pdf')}}</button>
                                    <qrcode-vue :value="item._id" :size="size" level="H" ref="qrCodeUrl"></qrcode-vue>
                                </td>
                                <td v-else-if="item.statusOrder.toUpperCase() != 'PAID' && checkReject(item)" >
                                    <button  @click="selectItem(item)" class="btn btn-danger w-100">{{$t('string.msg.dashboard.orders.btn.answer')}}</button>
                                </td>
                                <td v-if="checkReject(item)">
                                    <button v-on:click="confirmArchive(item)" class="text-dark-gray btn btn-warning w-50">{{$t('string.msg.order.status.reject')}}</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <Spinner />
        <Modal :order="order" :trucks="trucks" v-on:confirmation-return="updateScreen"/>
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" :order="orderSelected" v-on:confirmation-return="archive" />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtListOrdersServices';
import Spinner from '../../../../components/layout/Spinner';
import Toast from '../../../../components/layout/Toast';
import Confirmation from './Modal/Reject';
import Modal from './Modal/ModalOrderService';
import jsPDF from 'jspdf';
import QrcodeVue from 'qrcode.vue';
import Vue from 'vue'
import crono from 'vue-crono';
Vue.use(crono);

export default {
  name: 'ListOrdersServices',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast,
    Modal,
    Confirmation
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        valuekey:0,
        order:{},
        orderSelected: null,
        timer: '',
        trucks:null,
        nDays:2,
        value: '0',
        size: 100,
        filters: {
            typeOrder: "SERVICES",
            statusOrder: null,
            company: null,
            beginDate: new Date().setDate(new Date().getDate() - 1),
            endDate: new Date()
        }
      }
  },
  methods: Controller.methods,
  created() {
  },
  mounted(){
        let company = this.$session.get('user').companyUser.company;
        this.filters.company = company._id;
        Controller.init(this);
        this.filter();
  },
  cron:{
        time: 800000,
        method: 'load'
    },
  destroyed(){
     clearInterval(this.timer);
  },
  beforeDestroy () {
    clearInterval(this.timer);
  }
}
</script>

<style>
</style>
